import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';


const CustomerInvoiceAllPaymentDetails = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [value, setValue] = useState({});

  let currencySymbol ='dh';
  let { id } = useParams();


  useEffect(() => {
    axios
      .get(`/invoices/view-download/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.invoice);
          axios.get(`/invoices/payments/${id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            console.log(response);
    
            if (response.data.code === 200) {
              setData(response.data.data.payments);
              
            }
          })
          .catch((error) => {
            console.log(error);
          });
          
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }, [id]);

  useEffect(() => {
    axios
      .post(
        "/invoices/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.invoices);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const columns =
  [
    {
      accessorKey: 'payment_date', //normal accessorKey
      header: 'Payment Date',
    },
    {
      accessorKey: 'payment_amount', //normal accessorKey
      header: 'Payment Amount',
    },
    {
      accessorKey: 'exchange_date', //normal accessorKey
      header: 'Exchange Date',
    },
    {
      accessorKey: 'exchange_rate', //normal accessorKey
      header: 'Exchange Rate',
    },
   
   
    {
      header: 'Amount',
      accessorFn: (row) => `${row.amount}` +`${"MAD"} `,
    },
  
   ];



	
  return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Invoice Payment</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/customer/index">Customer Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/invoices-payments">Customer Invoice Payments</Link>
                    </li>
                    <li className="breadcrumb-item active">Invoice Payment</li>
                  </ul>
                </div>
               
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
              <div className="card customer-details-group">
                <div className="card-body">
                  <div className="row align-items-center">
                    
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-mail"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail "><g><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Invoice Number</h6>
                            <p>{value.invoice_number}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-airplay"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-airplay "><g><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Customer Name</h6>
                            <p> {value.customer_id
                                ? value.customer.company_name
                                : ""}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-phone"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-phone "><g><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Total Amount</h6>
                            <p>{value.total_amount}{currencySymbol}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-globe"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-globe "><g><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Payment Terms</h6>
                            <p> {value.customer && value.customer.payment_term
                                ? value.customer.payment_terms
                                    .delay1_description
                                : ""}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-calender"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-briefcase "><g><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Due Date</h6>
                            <p>{value.date}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>

            

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    <div className="table-responsive">
                    <MaterialReactTable columns={columns} data={data} 
                      enableColumnOrdering
                      enablePinning
                      // enableRowActions
                      //renderColumnActionsMenuItems 
                      //renderColumnActionsMenuItems 
                      // renderRowActionMenuItems={({ row }) => [
                      //   // <MenuItem key="edit" onClick={() => editItem(row.original)}>
                      //   //   Edit
                      //   // </MenuItem>,
                      // //   <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                      // //   View Customer Details
                      // // </MenuItem>,
                      // <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                      //     Delete
                      //   </MenuItem>,
                      // ]}
                    />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerInvoiceAllPaymentDetails;
